const SafetyIconTowable = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M13.5837 26.0661C12.8319 26.0661 12.1712 25.8301 11.6015 25.3582C11.0318 24.8862 10.6749 24.2794 10.5308 23.5378H9.15916C8.28436 23.5378 7.53893 23.2302 6.92287 22.6149C6.3068 21.9997 5.99919 21.2539 6.00003 20.3774V16.0995C6.00003 15.5331 6.19851 15.0511 6.59545 14.6533C6.99408 14.2555 7.47615 14.0566 8.04164 14.0566H12.9036V10.2642H6.63085C6.45134 10.2642 6.3009 10.2039 6.17954 10.0834C6.05819 9.96286 5.99835 9.81243 6.00003 9.63208C6.00172 9.45172 6.06198 9.30129 6.18081 9.18077C6.29964 9.06026 6.45007 9 6.63211 9H20.3924C20.9739 9 21.4598 9.1951 21.85 9.5853C22.2402 9.97551 22.4349 10.4614 22.434 11.0429V22.2736H27.9723L26.4111 20.7124C26.288 20.5893 26.2236 20.4444 26.2177 20.2775C26.2126 20.1106 26.2771 19.9577 26.4111 19.8186C26.551 19.6787 26.7014 19.6075 26.8624 19.605C27.0242 19.6025 27.1746 19.6711 27.3137 19.811L29.6941 22.1902C29.898 22.395 30 22.6335 30 22.9057C30 23.1779 29.898 23.416 29.6941 23.6199L27.3048 26.0079C27.1868 26.1259 27.0419 26.1891 26.87 26.1976C26.698 26.206 26.5446 26.1428 26.4098 26.0079C26.275 25.8731 26.2075 25.7239 26.2075 25.5604C26.2075 25.3969 26.275 25.2478 26.4098 25.1129L27.9875 23.5378H16.6354C16.5132 24.2794 16.1617 24.8862 15.5811 25.3582C15.0012 25.8301 14.3354 26.0661 13.5837 26.0661ZM14.2638 14.0566H21.1674V11.0429C21.1674 10.8482 21.0864 10.6695 20.9246 10.5069C20.7628 10.3442 20.5846 10.2633 20.3899 10.2642H14.2651L14.2638 14.0566ZM13.5837 24.8019C14.1045 24.8019 14.5508 24.6161 14.9224 24.2444C15.2941 23.8719 15.4799 23.4257 15.4799 22.9057C15.4799 22.3857 15.2941 21.9395 14.9224 21.567C14.5508 21.1945 14.1045 21.0086 13.5837 21.0095C13.0629 21.0103 12.617 21.1961 12.2462 21.567C11.8754 21.9378 11.6891 22.384 11.6875 22.9057C11.6858 23.4274 11.872 23.8736 12.2462 24.2444C12.617 24.6161 13.0629 24.8019 13.5837 24.8019ZM10.5308 22.2736C10.6749 21.532 11.0318 20.9252 11.6015 20.4532C12.1712 19.9813 12.8319 19.7453 13.5837 19.7453C14.3363 19.7453 15.0025 19.9813 15.5823 20.4532C16.163 20.9252 16.5148 21.532 16.6379 22.2736H21.1686V15.3208H8.04164C7.8141 15.3208 7.62742 15.3937 7.48162 15.5395C7.33582 15.6853 7.26292 15.8719 7.26292 16.0995V20.3774C7.26292 20.8974 7.44918 21.3436 7.82168 21.7161C8.1925 22.0878 8.63832 22.2736 9.15916 22.2736H10.5308Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIconTowable
